import { StandardEvents } from '@shopify/events';
const paint = count => {
  if (!Number.isFinite(count)) return;
  document.querySelectorAll('[data-dt-cart-count]').forEach(el => {
    el.textContent = String(count);
    el.closest('a')?.setAttribute('aria-label', `Shopping bag, ${count} items`);
  });
};
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ cart, detail }) => paint(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
});
window.addEventListener('pageshow', event => {
  if (!event.persisted || !document.querySelector('[data-dt-cart-count]')) return;
  fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' }).then(r => r.json()).then(cart => paint(cart.item_count)).catch(() => {});
});
